import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import image from "@assets/images/DietPlanHeader.png";
import BackImg from "@assets/images/stepsBack.jpg";
import {
  StressReduce,
  MovingMore,
  HealthyEat,
} from "@utils/defaultImages";
import RankUnlockedModal from "@components/common/FramerMotionModal";
import { useTranslation } from "react-i18next";

const ChallengeFinished = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  // Get data from location state or set to empty values
  const {
    submittedAnswers = {},
    totalPoints = 0,
    questionsLength = 0,
    badgeAchived = null,
    placesAchived = null,
    summary = "",
  } = location.state || {};

  // Redirect if no data is available
  useEffect(() => {
    if (!location.state) {
      navigate("/quiz-game");
    }
  }, [location.state, navigate]);

  useEffect(() => {
    if (badgeAchived || placesAchived) {
      setOpen(true);
    }
  }, [badgeAchived, placesAchived]);

  // Calculate stats from submitted answers
  const values = Object.values(submittedAnswers);
  const correctCount = values.filter((item) => item.isCorrect).length;
  const answeredCount = values.filter(
    (item) => item.selectedOption !== null
  ).length;
  const accuracy =
    answeredCount > 0 ? Math.round((correctCount / questionsLength) * 100) : 0;
  const pointeEarned = values.reduce((sum, item) => sum + item.points, 0);

  const nutrientData = [
    {
      label: t("quizGame.Questions Answered"),
      key: "stress",
      icon: <StressReduce className="w-[16px] h-[16px]" />,
      tabColor: "#FFF6F0",
      value: `${answeredCount}/${questionsLength}`,
    },
    {
      label: t("quizGame.Correct Answers"),
      key: "eatHealthy",
      icon: <HealthyEat className="w-[16px] h-[16px]" />,
      tabColor: "#F0FEFF",
      value: `${correctCount}/${questionsLength}`,
    },
    {
      label: t("quizGame.Accuracy"),
      key: "moving",
      icon: <MovingMore className="w-[16px] h-[16px]" />,
      tabColor: "#FFF0FB",
      value: `${accuracy}%`,
    },
    {
      label: t("quizGame.Points Earned"),
      key: "moving",
      icon: <MovingMore className="w-[16px] h-[16px]" />,
      tabColor: "#FFF0FB",
      value: `${pointeEarned}/${totalPoints}`,
    },
  ];

  // Don't render anything if redirecting
  if (!location.state) {
    return null;
  }

  return (
    <div
      className="bg-cover text-white relative rounded-[12px] p-5 xl:px-[150px] xl:py-[70px]"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="w-[100%]">
        <h1 className="text-[24px] text-white font-[700] font-[Lato] mb-3 text-center">
          {t("quizGame.Challenge Finished!")}
        </h1>
        <h2 className="text-[16px] font-[Lato] font-[500] m-0 text-center">
          {t("quizGame.Here’s how you did in this round.")}
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2 font-[Lato] gap-10 mt-10 mb-2">
        {nutrientData.map(({ label, icon, value, unit, tabColor }, index) => (
          <div
            key={index}
            className="py-5 px-3 rounded-[17px] bg-white border border-[#E6E6E6] rounded-[16px] grid grid-cols-1  items-center gap-2 justify-center"
            style={{
              boxShadow: "7px 7px 9.5px 0px #0000000D",
            }}
          >
            <div className="w-full flex justify-center">
              <div
                className="rounded-full w-11 h-11 flex items-center justify-center"
                style={{
                  backgroundColor: tabColor,
                }}
              >
                {icon}
              </div>
            </div>
            <div>
              <p className="text-[18px] font-[500] font-[Lato] text-[#6C6A6A] text-center ">
                {label}
              </p>
              <div className="">
                <p className="text-[14px] font-[500] font-[Lato] text-[#898787] text-center ">
                  {value}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
        <div
          className="bg-white p-[16px] font-[Lato] font-[500] text-[#6C6A6A] rounded-2xl my-8"
          // onClick={() => navigate("/quiz-game")}
        >
          {summary}
        </div>
      <div className="flex gap-2 items-center justify-center  flex-wrap flex-col md:flex-row">
        <button
          className="bg-[#4CFF7F] py-[12px] px-6 text-white rounded-full flex-1 max-w-[200px]"
          onClick={() => navigate("/quiz-game/start-quiz")}
        >
          {t("quizGame.Play Again")}
        </button>
        <button
          className="bg-[#64DDFF] py-[12px] px-6 text-white rounded-full "
          onClick={() => navigate("/quiz-game")}
        >
          {t("quizGame.Return To Dashboard")}
        </button>
      </div>
      <RankUnlockedModal
        isOpen={open}
        setIsOpen={setOpen}
        recent_milestone_achieved={badgeAchived}
        placesAchived={placesAchived}
      />
    </div>
  );
};

export default ChallengeFinished;
